<template>
  <div>
    <coming-soon-modal />
  </div>
</template>

<script>
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";
export default {
  name: 'UsageSettings',
  components: {
    ComingSoonModal,
  },
}
</script>

<style scoped>

</style>
